import {inArray} from "../../../helpers/arrays";
import {isEmpty, str_replace} from "../../../helpers/helpers";
import {getCityById, getCityURL, getDistricts} from "../../../../models/district";
import {getSearchLink} from "../../../../models/search";

const northCities = {
    1634: 'آمل',
    1351: 'بابلسر',
    1355: 'چالوس',
    //3614: 'چمستان',
    1364: 'محمود آباد',
    1367: 'نور',
    1368: 'نوشهر',
    1356: 'رامسر',
    3159: 'رویان',
    1358: 'سلمانشهر ( متل قو )',
    3661: 'سرخ رود',
    1353: 'تنکابن ( شهسوار )',
    1074: 'کیاشهر',
    1077: 'لاهیجان',
    4567: 'نشتارود',
    1360: 'فریدونکنار',
    1617: 'بندر انزلی',
    4939: 'چمخاله',
    3972: 'عباس آباد',
    1361: 'کلاردشت',
    10384: 'ایزدشهر',
};

export const northCitiesLanding = Object.keys(northCities);

export const northCitiesLandingUrl = () => {
    let urls = [];

    Object.keys(northCities).forEach(key => {
        const city = northCities[key];
        const city_url = str_replace(' ', '-', city);

        urls.push(`/املاک-${city_url}/خرید-فروش-ویلا`)
    });

    return urls;
};

export function checkRedirectToNorthCityLanding(city_id, deal_type, type) {
    let result = {
        redirect: false,
        landing: null,
    };


    if (inArray(city_id, northCitiesLanding) && deal_type === 'sale' && inArray(type, ['villa.house', 'villa'])) {
        result = {
            redirect: true,
            landing: 'north_city',
            city_id: city_id,
            type:'property'
        }
    }

    return result;
}

export async function getNorthCityData(city_id) {
    const city = await getCityById(city_id);

    let showOtherAreas = true;
    let specialDistricts = getSpecialDistricts(city_id);

    if (!specialDistricts.length) {
        showOtherAreas = false;

        specialDistricts = await getAllDistricts(city_id);
    }

    const city_name = getNorthCityName(city_id);
    const city_url = await getCityURL(city.name);
    const showVillaType = showVillaTypeBanner(city_id);

    return {
        specialDistricts,
        city_name,
        city_url,
        showVillaType,
        showOtherAreas
    }
}

function showVillaTypeBanner(city_id) {
    let type = 'default'; // 3 grid

    if (city_id === 3614) { // چمستان
        type = 'just_town';
    }

    return type;
}

function getNorthCityName(city_id) {
    return northCities[city_id];
}

function getSpecialDistricts(city_id) {
    const specialDistricts = {
        1634: [ // آمل
            {name: 'امامزاده عبدالله', url: '/املاک-آمل/خرید-فروش-ویلا/امامزاده-عبدالله'},
            {name: 'ولیسده', url: '/املاک-آمل/خرید-فروش-ویلا/جاده-ولیسده'},
            {name: 'امام خمینی', url: '/املاک-آمل/خرید-فروش-ویلا/خیابان-امام-خمینی(هراز-)'},
            {name: 'تلیران', url: '/املاک-آمل/خرید-فروش-ویلا/تلیران'},
            {name: 'امام رضا', url: '/املاک-آمل/خرید-فروش-ویلا/امام-رضا'},
        ],

        1351: [ // بابلسر
            {name: 'دریاکنار', url: '/املاک-بابلسر/خرید-فروش-ویلا/دریاکنار'},
            {name: 'صفائیه', url: '/املاک-بابلسر/خرید-فروش-ویلا/صفائیه-(-روبروی-دریاکنار-)'},
            {name: 'هادی‌شهر', url: '/املاک-بابلسر/خرید-فروش-ویلا/هادی-شهر'},
            {name: 'خزرشهر', url: '/املاک-بابلسر/خرید-فروش-ویلا/خزرشهر'},
            {name: 'بهنمیر', url: '/املاک-بابلسر/خرید-فروش-ویلا/بهنمیر'},
            {name: 'عربخیل', url: '/املاک-بابلسر/خرید-فروش-ویلا/عربخیل'},
            {name: 'نیرو هوایی', url: '/املاک-بابلسر/خرید-فروش-ویلا/نیرو-هوایی'},
        ],

        1355: [ // چالوس
            {name: 'نمک‌آبرود', url: '/املاک-چالوس/خرید-فروش-ویلا/نمک-آبرود'},
            {name: 'کلارآباد', url: '/املاک-چالوس/خرید-فروش-ویلا/کلار-آباد'},
            {name: 'هچیرود', url: '/املاک-چالوس/خرید-فروش-ویلا/هچیرود'},
            {name: 'امام‌رود', url: '/املاک-چالوس/خرید-فروش-ویلا/امام-رود'},
            {name: 'رادیو دریا', url: '/املاک-چالوس/خرید-فروش-ویلا/رادیو-دریا'},
            {name: 'خط هشت', url: '/املاک-چالوس/خرید-فروش-ویلا/خط-هشت'},
            {name: 'شهرک دریانوردان', url: '/املاک-چالوس/خرید-فروش-ویلا/شهرک-دریانوردان'},
            {name: 'فرج‌آباد', url: '/املاک-چالوس/خرید-فروش-ویلا/فرج-آباد'},
            {name: 'دوستگر', url: '/املاک-چالوس/خرید-فروش-ویلا/دوستگر'},
        ],

        3614: [ // چمستان
            {name: 'نور', url: '/املاک-نور/خرید-فروش-ویلا'},
            {name: 'بهدشت', url: '/املاک-چمستان/خرید-فروش-ویلا/بهدشت'},
            {name: 'آهودشت', url: '/املاک-چمستان/خرید-فروش-ویلا/آهودشت'},
            {name: 'امیرآباد', url: '/املاک-چمستان/خرید-فروش-ویلا/امیرآباد'},
            {name: 'لاویج', url: '/املاک-چمستان/خرید-فروش-ویلا/لاویج'},
            {name: 'سعادت‌آباد', url: '/املاک-چمستان/خرید-فروش-ویلا/سعادت-آباد'},
            {name: 'جوربند', url: '/املاک-چمستان/خرید-فروش-ویلا/جوربند'},
            {name: 'آپادانا', url: '/املاک-چمستان/خرید-فروش-ویلا/آپادانا'},
            {name: 'نعمت‌آباد', url: '/املاک-چمستان/خرید-فروش-ویلا/نعمت-آباد'},
            {name: 'رزک', url: '/املاک-چمستان/خرید-فروش-ویلا/رزک'},
            {name: 'عبداله‌آباد', url: '/املاک-چمستان/خرید-فروش-ویلا/عبداله-آباد'},
            {name: 'جلیکان', url: '/املاک-چمستان/خرید-فروش-ویلا/جلیکان'},
            {name: 'اسپی‌کلا', url: '/املاک-چمستان/خرید-فروش-ویلا/اسپی-کلا'},
            {name: 'همصفا', url: '/املاک-چمستان/خرید-فروش-ویلا/همصفا'},
            {name: 'سنگینده', url: '/املاک-چمستان/خرید-فروش-ویلا/سنگینده'}
        ],

        1364: [ // محمود آباد
            {name: 'کلوده', url: '/املاک-محمود-آباد/خرید-فروش-ویلا/کلوده'},
            {name: 'بیشه‌کلا', url: '/املاک-محمود-آباد/خرید-فروش-ویلا/بیشه-کلا'},
            {name: 'چهارمحل آهی', url: '/املاک-محمود-آباد/خرید-فروش-ویلا/چهارمحل-آهی'},
            {name: 'تشبندان', url: '/املاک-محمود-آباد/خرید-فروش-ویلا/تشبندان'},
            {name: 'آزادمون', url: '/املاک-محمود-آباد/خرید-فروش-ویلا/آزادمون'},
            {name: 'سیاهرودسر', url: '/املاک-محمود-آباد/خرید-فروش-ویلا/سیاهرودسر'},
        ],

        1367: [ // نور
            {name: 'دشت نور', url: '/املاک-نور/خرید-فروش-ویلا/دشت-نور'},
            {name: 'سعادت‌آباد نور', url: '/املاک-نور/خرید-فروش-ویلا/سعادت-آباد'},
            {name: 'واز', url: '/املاک-نور/خرید-فروش-ویلا/واز'},
            {name: 'روستا بالاسالده', url: '/املاک-نور/خرید-فروش-ویلا/روستا-بالا-سالده'},
            {name: 'رستم‌رود', url: '/املاک-نور/خرید-فروش-ویلا/جاده-رستم-رود'},
            {name: 'امیرآباد', url: '/املاک-نور/خرید-فروش-ویلا/امیرآباد'},
            {name: 'آب‌پری', url: '/املاک-نور/خرید-فروش-ویلا/آب-پری'},
            {name: 'عباسا', url: '/املاک-نور/خرید-فروش-ویلا/عباسا'},
            {name: 'پارک جنگلی', url: '/املاک-نور/خرید-فروش-ویلا/پارک-جنگلی'},
            {name: 'شیرکلا', url: '/املاک-نور/خرید-فروش-ویلا/شیرکلا'},
            {name: 'سیاهکلا', url: '/املاک-نور/خرید-فروش-ویلا/سیاهکلا'},
            {name: 'سلیاکتی', url: '/املاک-نور/خرید-فروش-ویلا/سلیاکتی'},
            {name: 'شهربند', url: '/املاک-نور/خرید-فروش-ویلا/شهربند'},
            {name: 'گنج‌یاب', url: '/املاک-نور/خرید-فروش-ویلا/گنج-یاب'},
            {name: 'معصوم‌آباد', url: '/املاک-نور/خرید-فروش-ویلا/معصوم-آباد'},
            {name: 'کیابسر', url: '/املاک-نور/خرید-فروش-ویلا/کیابسر'},
            {name: 'باریکلا', url: '/املاک-نور/خرید-فروش-ویلا/باریکلا'},
            {name: 'گیلانده', url: '/املاک-نور/خرید-فروش-ویلا/گیلانده'},
            {name: 'رمشی', url: '/املاک-نور/خرید-فروش-ویلا/رمشی'},
            {name: 'حاجی‌آباد', url: '/املاک-نور/خرید-فروش-ویلا/حاجی-آباد'},
            {name: 'الیمالات', url: '/املاک-نور/خرید-فروش-ویلا/الیمالات'},
        ],

        1368: [ // نوشهر
            {name: 'چلک', url: '/املاک-نوشهر/خرید-فروش-ویلا/چلک'},
            {name: 'ونوش', url: '/املاک-نوشهر/خرید-فروش-ویلا/ونوش'},
            {name: 'چلندر', url: '/املاک-نوشهر/خرید-فروش-ویلا/چلندر'},
            {name: 'انارور', url: '/املاک-نوشهر/خرید-فروش-ویلا/انارور'},
            {name: 'کجور', url: '/املاک-نوشهر/خرید-فروش-ویلا/جاده-کجور'},
            {name: 'سیسنگان', url: '/املاک-نوشهر/خرید-فروش-ویلا/سیسنگان'},
            {name: 'لتینگان', url: '/املاک-نوشهر/خرید-فروش-ویلا/لتینگان'},
            {name: 'توسکا', url: '/املاک-نوشهر/خرید-فروش-ویلا/توسکا'},
            {name: 'مزگاه', url: '/املاک-نوشهر/خرید-فروش-ویلا/مزگاه'},
            {name: 'نیرنگ', url: '/املاک-نوشهر/خرید-فروش-ویلا/نیرنگ'},
            {name: 'ملکار', url: '/املاک-نوشهر/خرید-فروش-ویلا/ملکار'},
            {name: 'دهکده سبز', url: '/املاک-نوشهر/خرید-فروش-ویلا/دهکده-سبز'},
            {name: 'کندلوس', url: '/املاک-نوشهر/خرید-فروش-ویلا/کندلوس'},
            {name: 'هلستان', url: '/املاک-نوشهر/خرید-فروش-ویلا/هلستان'},
        ],

        1356: [ // رامسر
            {name: 'سادات‌شهر', url: '/املاک-رامسر/خرید-فروش-ویلا/سادات-شهر'},
            {name: '400 دستگاه', url: '/املاک-رامسر/خرید-فروش-ویلا/شهرک-400-دستگاه'},
            {name: 'کتالم', url: '/املاک-رامسر/خرید-فروش-ویلا/کتالم'},
            {name: 'بلوار معلم', url: '/املاک-رامسر/خرید-فروش-ویلا/بلوار-معلم'},
            {name: 'اربکله', url: '/املاک-رامسر/خرید-فروش-ویلا/جاده-اربکله'},
            {name: 'جواهرده', url: '/املاک-رامسر/خرید-فروش-ویلا/جواهرده'},
            {name: 'بلوار طالقانی', url: '/املاک-رامسر/خرید-فروش-ویلا/بلوار-طالقانی'},
            {name: 'ابریشم‌محله', url: '/املاک-رامسر/خرید-فروش-ویلا/ابریشم-محله'},
        ],

        3159: [ // رویان
            {name: 'وازیوار', url: '/املاک-رویان/خرید-فروش-ویلا/وازیوار'},
            {name: 'سیاهرود', url: '/املاک-رویان/خرید-فروش-ویلا/سیاهرود'},
            {name: 'دریابیشه', url: '/املاک-رویان/خرید-فروش-ویلا/دریابیشه'},
            {name: 'حسن‌آباد', url: '/املاک-رویان/خرید-فروش-ویلا/حسن-آباد'},
            {name: 'گلندرود', url: '/املاک-رویان/خرید-فروش-ویلا/خیابان-گلندرود'},
            {name: 'بنجکول', url: '/املاک-رویان/خرید-فروش-ویلا/بنجکول'},
        ],

        1358: [ // سلمانشهر
            {name: 'دریاگوشه', url: '/املاک-سلمانشهر-(-متل-قو-)/خرید-فروش-ویلا/خیابان-دریا-گوشه'},
            {name: 'شهرک لاکوده', url: '/املاک-سلمانشهر-(-متل-قو-)/خرید-فروش-ویلا/شهرک-لاکوده'},
            {name: 'تیلاکنار', url: '/املاک-سلمانشهر-(-متل-قو-)/خرید-فروش-ویلا/تیلاکنار'},
            {name: 'دهکده شیرین', url: '/املاک-سلمانشهر-(-متل-قو-)/خرید-فروش-ویلا/دهکده-شیرین'},
            {name: 'خیابان آرا', url: '/املاک-سلمانشهر-(-متل-قو-)/خرید-فروش-ویلا/خیابان-آرا'},
            {name: 'جمشیدآباد', url: '/املاک-سلمانشهر-(-متل-قو-)/خرید-فروش-ویلا/جمشید-آباد'},
            {name: 'شهرک باران', url: '/املاک-سلمانشهر-(-متل-قو-)/خرید-فروش-ویلا/شهرک-باران'},
            {name: 'دانیال', url: '/املاک-سلمانشهر-(-متل-قو-)/خرید-فروش-ویلا/دانیال'},
            {name: 'نارنج بندبن', url: '/املاک-سلمانشهر-(-متل-قو-)/خرید-فروش-ویلا/نارنج-بندبن'},
            {name: 'شمس‌آباد', url: '/املاک-سلمانشهر-(-متل-قو-)/خرید-فروش-ویلا/شمس-آباد'},
        ],

        3661: [ // سرخ رود
            {name: 'خط دریا', url: '/املاک-سرخ-رود/خرید-فروش-ویلا/خط-دریا'},
            {name: 'چاکسر', url: '/املاک-سرخ-رود/خرید-فروش-ویلا/چاکسر'},
            {name: 'عزت‌آباد', url: '/املاک-سرخ-رود/خرید-فروش-ویلا/عزت-آباد'},
            {name: 'فرزادشهر', url: '/املاک-سرخ-رود/خرید-فروش-ویلا/فرزادشهر'},
            {name: 'حاجی‌کلا سفلی', url: '/املاک-سرخ-رود/خرید-فروش-ویلا/حاجی-کلا-سفلی'},
        ],

        1353: [ // تنکابن
            {name: 'جاده دوهزار', url: '/املاک-تنکابن-(-شهسوار-)/خرید-فروش-ویلا/جاده-دوهزار'},
            {name: 'خرم‌آباد', url: '/املاک-تنکابن-(-شهسوار-)/خرید-فروش-ویلا/خرم-آباد'},
            {name: 'نعمت‌آباد', url: '/املاک-تنکابن-(-شهسوار-)/خرید-فروش-ویلا/جاده-نعمت-آباد'},
            {name: 'ولی‌آباد', url: '/املاک-تنکابن-(-شهسوار-)/خرید-فروش-ویلا/ولی-آباد'},
            {name: 'سلیمان‌آباد', url: '/املاک-تنکابن-(-شهسوار-)/خرید-فروش-ویلا/سلیمان-آباد'},
            {name: 'لزربن', url: '/املاک-تنکابن-(-شهسوار-)/خرید-فروش-ویلا/لزربن'},
            {name: 'آلکله', url: '/املاک-تنکابن-(-شهسوار-)/خرید-فروش-ویلا/آلکله'},
            {name: 'پلت کله', url: '/املاک-تنکابن-(-شهسوار-)/خرید-فروش-ویلا/پلت-کله'},
            {name: 'امین‌آباد', url: '/املاک-تنکابن-(-شهسوار-)/خرید-فروش-ویلا/امین-آباد'},
            {name: 'لشگرک', url: '/املاک-تنکابن-(-شهسوار-)/خرید-فروش-ویلا/لشگرک'},
            {name: 'کارکو', url: '/املاک-تنکابن-(-شهسوار-)/خرید-فروش-ویلا/کارکو'},
            {name: 'زوار', url: '/املاک-تنکابن-(-شهسوار-)/خرید-فروش-ویلا/زوار'},
        ]
    };

    return !isEmpty(specialDistricts[city_id]) ? specialDistricts[city_id] : [];
}

async function getAllDistricts(city_id) {
    let items = [];
    const districtsResult = await getDistricts(city_id);

    if (districtsResult) {
        const {districts} = districtsResult;

        for (let district of districts) {
            const data = {
                city_id: city_id,
                deal_type: 'sale',
                types: ['villa.house'],
                district_id: district.id
            };
            const {url} = await getSearchLink(data);

            items.push({name: district.name, url: url},)
        }
    }

    return items;
}